<template>
  <div class="relative mt-1">
    <div
      class="text-xs text-red-600 w-full"
      v-for="(error, index) in errors"
      :key="key(index)"
    >
      {{ error }}
    </div>
  </div>
</template>
<script>
export default {
  props: ["errors"],
  methods: {
    key(index) {
      return `validation_error_${index}_${Math.random}`;
    },
  },
};
</script>
